export default __webpack_public_path__ + "static/media/electronics.f1c55c2c.svg";